import { Link, useNavigate } from "react-router-dom";
import { HelpCircle, LogOut, Plus, ScanLine } from "lucide-react";

import { useAuth } from "@/auth/useAuth";
import { VaultMark } from "@/auth/LoginPage";
import { Button, IconButton } from "@/components/Button";
import { GlobalSearch } from "./GlobalSearch";

export function TopBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const initials = (user?.display_name ?? "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 border-b border-border bg-surface/95 px-3 py-2.5 backdrop-blur md:px-4 desk:px-5">
      <Link to="/dashboard" className="flex items-center gap-2 md:hidden" aria-label="HD-Vault">
        <VaultMark className="size-8" />
      </Link>

      {/* min-w-0 is what lets the search actually shrink instead of pushing the
          buttons off the edge. */}
      <div className="min-w-0 flex-1 @5xl:max-w-2xl">
        <GlobalSearch />
      </div>

      <div className="flex shrink-0 items-center gap-1.5">
        {/* Wrapped rather than given `hidden` directly: a display utility on the
            button itself competes with its own `inline-flex` base.

            The labels drop before the buttons do: losing "Ajouter" from a button
            still leaves a usable "+", while losing the button entirely leaves
            nothing. */}
        <div className="hidden items-center gap-1.5 @xl:flex">
          <Button variant="primary" size="sm" onClick={() => navigate("/inventory/add")}>
            <Plus className="size-4" aria-hidden />
            <span className="hidden @3xl:inline">Ajouter</span>
          </Button>
          <Button variant="secondary" size="sm" onClick={() => navigate("/blitz")}>
            <ScanLine className="size-4" aria-hidden />
            <span className="hidden @3xl:inline">Blitz</span>
          </Button>
          <IconButton
            label="Aide"
            variant="ghost"
            size="sm"
            className="hidden @5xl:inline-flex"
            onClick={() => navigate("/help")}
          >
            <HelpCircle className="size-4" aria-hidden />
          </IconButton>
        </div>

        <div className="flex shrink-0 items-center gap-2 rounded-md border border-border bg-surface-raised px-2 py-1">
          <span className="flex size-7 items-center justify-center rounded-full bg-brand text-[11px] font-semibold text-ink-inverse">
            {initials || "?"}
          </span>
          <span className="hidden min-w-0 leading-tight @3xl:block">
            <span className="block truncate text-[12px] font-medium text-ink">
              {user?.display_name}
            </span>
            <span className="block truncate text-[10px] text-ink-subtle">{user?.role}</span>
          </span>
          <IconButton label="Se déconnecter" variant="ghost" size="sm" onClick={logout}>
            <LogOut className="size-4" aria-hidden />
          </IconButton>
        </div>
      </div>
    </header>
  );
}
